import {
  DetailedHTMLProps,
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';

interface HiddenFileUploadInputProps
  extends Pick<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    'accept' | 'onChange'
  > {}

export const HiddenFileUploadInput = forwardRef(
  (props: HiddenFileUploadInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    const { accept, onChange } = props;

    return (
      <input
        type="file"
        className="hidden"
        onChange={onChange}
        accept={accept}
        ref={ref}
      />
    );
  }
);
